class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector('.swiper-container');
    this.slides = this.querySelectorAll('.swiper-slide');
    this.buttonPrev = this.querySelector('.slider-button-prev');
    this.buttonNext = this.querySelector('.slider-button-next');
    this.sliderDots = this.querySelector('.slider-dots');
    this.sliderScrollbar = this.querySelector('.slider-scrollbar');
    this.slider = null;
    const optionsJSONHTML = this.querySelector('[data-slider-options-json]');
    this.options = optionsJSONHTML ? JSON.parse(optionsJSONHTML.innerHTML) : {};
    const minSlides = this.options.minSlides ?? 1;

    if (this.options.breakpointDestroy) {
      this.breakpoint = window.matchMedia(`(min-width:${this.options.breakpointDestroy}px)`);

      if (this.sliderElement && this.slides.length >= minSlides && this.breakpoint.matches) {
        onLibReady(['swiper'], this.initSlider.bind(this));
      }

      this.breakpoint.addListener(this.breakpointChecker.bind(this));
    } else if (this.sliderElement && this.slides.length >= minSlides) {
      onLibReady(['swiper'], this.initSlider.bind(this));
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (this.slider && entries[0].isIntersecting) {
          this.slider.update();
        }
      });

      observer.observe(this);
    }
  }

  initSlider() {
    this.slider = new Swiper(
      this.sliderElement,
      Object.assign({}, this.options, {
        watchOverflow: true,
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
        pagination: {
          el: this.sliderDots,
          type: 'bullets',
          clickable: true,
        },
        scrollbar: {
          el: this.sliderScrollbar,
          draggable: true,
        },
      }),
    );
  }

  breakpointChecker() {
    if (this.breakpoint.matches) {
      this.initSlider();
    } else {
      this.slider !== undefined && this.slider.destroy(true, true);
    }
  }
}

customElements.define('custom-slider', CustomSlider);
